'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  OfferConditionTypeEnumV2,
  type SellerPromotionV2,
} from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../global-config'
import { productAccessorOfferHasFreeItemSellerPromotion } from '../../models'

type ProductSellerPromotionFlagProps = {
  sellerPromotion: SellerPromotionV2
}

export const ProductSellerPromotionFlag: FC<
  ProductSellerPromotionFlagProps
> = ({ sellerPromotion }) => {
  const { superScripts } = useGlobalConfigContext()

  const legalFootnoteNumber = superScripts.sellerPromotions ? (
    <sup key="sellerPromotions">{superScripts.sellerPromotions}</sup>
  ) : null

  if (productAccessorOfferHasFreeItemSellerPromotion(sellerPromotion)) {
    return (
      <FormattedMessage
        id="seller.promotion.product.badge.freeItems"
        values={{
          payableItemCount:
            sellerPromotion.conditionValue - sellerPromotion.discountValue,
          sup: legalFootnoteNumber,
          targetItemCount: sellerPromotion.conditionValue,
        }}
      />
    )
  }

  if (
    sellerPromotion.conditionType === OfferConditionTypeEnumV2.MinimumOrderValue
  ) {
    return (
      <FormattedMessage
        id="seller.promotion.product.badge.discount.mov"
        values={{
          sup: legalFootnoteNumber,
        }}
      />
    )
  }

  return (
    <FormattedMessage
      id="seller.promotion.product.badge.discount"
      values={{
        sup: legalFootnoteNumber,
      }}
    />
  )
}
